/*
 * @Author: changcheng
 * @LastEditTime: 2023-03-24 10:15:48
 */
import React, { FC, useEffect, useState } from "react";
import { Table, Space, Button, message, Select, Form } from "antd";
import axios from "@/axios/axios";
const { Option } = Select;
export const CardBindRecord: FC<any> = ({ history, storeData }) => {
  const [count, setCount] = useState(0);
  const [year, setYear] = useState(2023);
  const [page, setPage] = useState({
    currentPage: 1,
    pageSize: 10,
    totalResultSize: 0,
  });
  const onChange = (pageNumber: any) => {
    let newPage = { ...page, currentPage: pageNumber };
    setPage(newPage);
    setCount(count + 1);
  };
  useEffect(() => {
    getList();
  }, [count, year]);
  // 纪录列表
  const [list, setList] = useState([]);
  const getList = async () => {
    const body = {
      year,
      page: {
        currentPage: page.currentPage,
        pageSize: page.pageSize,
      },
    };
    const {
      code,
      data: {
        itemUserCardList,
        page: { currentPage, totalResultSize },
      },
      msg,
    }: any = await axios.post(`/shop/front/ce/user/bind/card/list`, body);
    if (code === 0) {
      setList(itemUserCardList || []);
      setPage({
        ...page,
        currentPage,
        totalResultSize,
      });
    } else {
      message.error(msg);
    }
  };
  const columns = [
    {
      title: "绑定时间",
      dataIndex: "createTime",
      key: "createTime",
    },
    {
      title: "绑定手机号码",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "卡号",
      dataIndex: "cardNo",
      key: "cardNo",
    },
    {
      title: "密码",
      dataIndex: "cardPassword",
      key: "cardPassword",
    },
  ];
  const onFinish = () => {};
  return (
    <div>
      <h2>绑卡记录</h2>
      {/* <Form
        onFinish={onFinish}
        initialValues={{
          year: 2023,
        }}
      >
        <Form.Item label="年度" name="year">
          <Select
            style={{ width: "200px" }}
            onChange={(value) => {
              setYear(value);
            }}
          >
            <Option value={2021}>2021年度</Option>
            <Option value={2022}>2022年度</Option>
            <Option value={2023}>2023年度</Option>
          </Select>
        </Form.Item>
      </Form> */}
      <Table
        bordered={true}
        dataSource={list}
        columns={columns}
        pagination={{ onChange: () => onChange }}
      />
    </div>
  );
};
